import { CalendarClock, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function AnnouncementBar() {
  const a = SITE.announcement;
  if (!a?.show) return null;

  return (
    <div
      data-testid="announcement-bar"
      className="bg-[#0B2545] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.18] [background-image:radial-gradient(circle_at_15%_50%,#14B8A6_1px,transparent_1px)] [background-size:18px_18px]" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-10 lg:px-12 py-2.5 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-1.5 sm:gap-4 text-center sm:text-left">
        <div className="inline-flex items-center gap-2 text-sm">
          <CalendarClock className="w-4 h-4 text-[#2DD4BF] shrink-0" />
          <span className="font-semibold">{a.title}</span>
          <span className="hidden md:inline text-white/70">— {a.detail}</span>
        </div>
        <a
          href={`tel:${SITE.phoneRaw}`}
          data-testid="announcement-call"
          className="inline-flex items-center gap-1.5 text-xs font-bold tracking-wide bg-[#14B8A6] hover:bg-[#0D9488] text-white px-3 py-1 rounded-full transition-colors shrink-0"
        >
          <Phone className="w-3.5 h-3.5" /> Book Sunday Slot
        </a>
      </div>
    </div>
  );
}
